module.exports = "<section class=\"\"> <div class=l-container> <onboarding-status></onboarding-status> </div> </section> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/onboarding/onboarding.html
// module id = 1797
// module chunks = 86